import React, { useState } from 'react';
import '../NavBar/navBar.css';
import { Link} from 'react-router-dom';

const NavBar = () => {
  // const navigate = useNavigate(); 
  const [isMobile, setIsMobile] = useState(false);

  // const logoutHandler = () => {
  //   localStorage.clear();
  //   navigate('/login'); 
  // };

  const toggleMobileMenu = () => {
    setIsMobile(!isMobile);
  };

  return (
    <nav className='nav-bar'>
      <div className='logo'>
        <p><span className='logo-text'>P.K</span> Real Estate</p>
      </div>
      <div className={`menu ${isMobile ? 'active' : ''}`}>
        <Link className='links' to='/uhome/home'>Home</Link>
        <Link className='links' to='/uhome/property'>Properties</Link>
        <Link className='links' to='/uhome/about'>About</Link>
        <Link className='links' to='/uhome/contact'>Contact Us</Link>
        <p className='Usernnamee' >Hello {localStorage.getItem('userName')}!</p>
              {/* <button className='Logoutbtn' onClick={logoutHandler}>Logout</button> */}
      </div>
      <div className='hamburger' onClick={toggleMobileMenu}>
        <div className='bar'></div>
        <div className='bar'></div>
        <div className='bar'></div>
      </div>
    </nav>
  );
}

export default NavBar;
